// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import DocumentFormController from "./document_form_controller"
application.register("document-form", DocumentFormController)

import ArticleEditorController from "./article_editor_controller"
application.register("article-editor", ArticleEditorController)

import ReportOfficialsController from "./report_officials_controller"
application.register("report-officials", ReportOfficialsController)

import ScoreEntryController from "./score_entry_controller"
application.register("score-entry", ScoreEntryController)

import CompetitionSeriesController from "./competition_series_controller"
application.register("competition-series", CompetitionSeriesController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)
